import sanityClient from '@sanity/client'
// import sanityClient from '../studio/config/@sanity'

export default sanityClient({
    projectId: "xlw48r01",
    dataset: "production"
})